import { useEffect, useState } from 'react';
import api from '../services/api';
import { sortLevels } from '../utils/levels';

// Module-level cache so all components share one fetch per page-load.
let cache = null;
let inflight = null;
const subscribers = new Set();

const notify = () => {
  for (const fn of subscribers) fn(cache);
};

const fetchLevels = () => {
  if (cache) return Promise.resolve(cache);
  if (inflight) return inflight;
  inflight = api
    .get('/levels')
    .then((res) => {
      cache = sortLevels(res.data?.levels ?? []);
      inflight = null;
      notify();
      return cache;
    })
    .catch((err) => {
      inflight = null;
      throw err;
    });
  return inflight;
};

/**
 * Force a refresh — used by the admin page after CRUD operations
 * so every other view sees the new levels without a page reload.
 */
export const refreshLevels = () => {
  cache = null;
  inflight = null;
  return fetchLevels();
};

export const useLevels = () => {
  const [levels, setLevels] = useState(cache);
  const [loading, setLoading] = useState(!cache);

  useEffect(() => {
    let cancelled = false;
    const sub = (next) => {
      if (!cancelled) setLevels(next);
    };
    subscribers.add(sub);

    if (!cache) {
      fetchLevels()
        .catch(() => {})
        .finally(() => { if (!cancelled) setLoading(false); });
    } else {
      setLoading(false);
    }

    return () => {
      cancelled = true;
      subscribers.delete(sub);
    };
  }, []);

  return { levels: levels ?? [], loading };
};
